import React from "react";
import {
  SnackbarProvider as Provider,
  MaterialDesignContent,
  closeSnackbar,
} from "notistack";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent": {
    fontSize: "14px",
    fontWeight: "600",
    maxWidth: "533px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
  },
  "&.notistack-MuiContent-success": {
    border: "1px solid #A2F0D0",
    color: "#00C472",
    backgroundColor: "#F8FFFC",
  },
  "&.notistack-MuiContent-error": {
    border: "1px solid #E25D5D",
    backgroundColor: "#FFE2E2",
    color: "#E25D5D",
  },
  "&.notistack-MuiContent-info": {
    border: "1px solid #73D3F5",
    backgroundColor: "#DEF5FD",
    color: "#2ABDF0",
  },
  "&.notistack-MuiContent-notification": {
    fontSize: "16px",
    boxShadow: `0px 4px 8px -4px #3A354129,
                0px 6px 10px -4px #3A354114,
                0px 4px 6px -4px #3A35411A`,
    backgroundColor: "#E5F8FF",
    color: "#101828",
  },
}));

const SnackbarProvider = ({ children }) => {
  return (
    <Provider
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        notification: StyledMaterialDesignContent,
      }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      autoHideDuration={3000}
      maxSnack={3}
      hideIconVariant
      preventDuplicate
      action={(snackbarId) => (
        <IconButton
          color="inherit"
          size="small"
          onClick={() => closeSnackbar(snackbarId)}>
          <CloseIcon />
        </IconButton>
      )}>
      {children}
    </Provider>
  );
};

export default SnackbarProvider;
